function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime } from 'luxon';
import './MotoEntryPanel.css';

var MotoEntryPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(MotoEntryPanel, _React$Component);

  function MotoEntryPanel(props) {
    var _this;

    _classCallCheck(this, MotoEntryPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MotoEntryPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeMotoNumber", function (moto, number) {
      var updateLogBookEntry = _this.props.updateLogBookEntry;
      moto.number = number;
      updateLogBookEntry();
    });

    _defineProperty(_assertThisInitialized(_this), "changeMotoFinish", function (moto, number) {
      var updateLogBookEntry = _this.props.updateLogBookEntry;
      moto.finish = number.substring(number.length - 1, number.length);

      if (moto.finish === '9') {
        moto.finish = '';
      }

      updateLogBookEntry();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      if (event.which === 13) {
        event.target.blur();
      }
    });

    _this.state = {
      locked: false
    };
    return _this;
  }

  _createClass(MotoEntryPanel, [{
    key: "render",
    value: function render() {
      var changeMotoNumber = this.changeMotoNumber,
          changeMotoFinish = this.changeMotoFinish,
          handleKeyPress = this.handleKeyPress;
      var _this$props = this.props,
          moto = _this$props.moto,
          selectMoto = _this$props.selectMoto,
          mapMotoName = _this$props.mapMotoName;
      return React.createElement("div", {
        className: "round"
      }, React.createElement("div", {
        className: "title",
        dangerouslySetInnerHTML: {
          __html: mapMotoName(moto.name)
        },
        onClick: function onClick(e) {
          return selectMoto(moto);
        }
      }), React.createElement("div", {
        className: "number"
      }, React.createElement("input", {
        type: "number",
        value: moto.number,
        placeholder: "#",
        onChange: function onChange(e) {
          changeMotoNumber(moto, e.target.value);
        },
        onKeyPress: handleKeyPress
      })), React.createElement("div", {
        className: "finish"
      }, React.createElement("input", {
        type: "number",
        value: moto.finish,
        placeholder: "place",
        onChange: function onChange(e) {
          changeMotoFinish(moto, e.target.value);
        },
        onKeyPress: handleKeyPress
      })));
    }
  }]);

  return MotoEntryPanel;
}(React.Component);

export default MotoEntryPanel;